module.exports = __webpack_public_path__ + "5b73df3419d05723fe0d4eefb5f934b5.gif";